(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc-b2b"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => {
    const request = document.querySelector('.hc-request');
    if (!request) return;
    const kind = request.querySelector('[name="contact[Anfrageart]"]');
    const body = request.querySelector('[name="contact[body]"]');
    if (!kind || !body) return;
    const defaults = {vehicle:'Fahrzeugersatzteile', industry:'Industrielle Beschaffung', supplier:'Lieferantensuche'};
    if (defaults[request.dataset.defaultService]) kind.value = defaults[request.dataset.defaultService];
    const update = () => request.querySelectorAll('[data-hc-detail]').forEach(group => {
      group.hidden = group.dataset.hcDetail !== kind.value;
      group.querySelectorAll('input, select, textarea').forEach(input => { input.disabled = group.hidden; });
    });
    if (!kind.dataset.hcReady) { kind.dataset.hcReady = 'true'; kind.addEventListener('change', update); }
    update();
    const append = text => { if (text && !body.value.includes(text)) body.value += (body.value.trim() ? '\n\n' : '') + text; };
    document.querySelectorAll('[data-hc-text], [data-hc-service], [data-hc-search-request]').forEach(button => {
      if (button.dataset.hcReady) return;
      button.dataset.hcReady = 'true';
      button.addEventListener('click', event => {
        if (button.hasAttribute('data-hc-text')) {
          append(button.dataset.hcText);
          const status = request.querySelector('[data-hc-status]');
          if (status) status.textContent = status.dataset.added;
          body.focus();
        } else if (button.hasAttribute('data-hc-search-request')) {
          append(button.closest('form').querySelector('[name="q"]').value.trim());
          request.scrollIntoView({behavior:'smooth',block:'start'}); body.focus({preventScroll:true});
        } else {
          const values = {vehicle:'Fahrzeugersatzteile', industry:'Industrielle Beschaffung', supplier:'Lieferantensuche'};
          if (values[button.dataset.hcService]) { event.preventDefault(); kind.value = values[button.dataset.hcService]; update();
            const project = request.querySelector('[name="contact[Projektart]"]');
            if (project && button.dataset.hcProject) {
              const option = Array.from(project.options).find(item => item.dataset.project === button.dataset.hcProject);
              if (option) project.value = option.value;
            } request.scrollIntoView({behavior:'smooth',block:'start'}); kind.focus({preventScroll:true}); }
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
